import { get } from 'lodash';
import React from 'react';
import { getLocalstorageToken } from '../../../../../../../../context/AuthHelper';
import { KOSTENTRAEGER } from '../../../../../../../../lib/constants/constant';
import EffekteDerFoerderungAbschlussEMob, { getFormStrucEffekteDerFoerderungAbschlussEMob } from './EffekteDerFoerderungAbschlussEMob';

// import schemas
import Schema from '../../../../../../../../lib/paths/abschlussbericht_FULL_Paths.json';
const P = Schema.attributes;

export const GetEffekteDerFoerderungAbschlusEmob = (application: any) => {
	const OrgaStruc = [
		{
			label: get(application, P.Foerderantrag.schema.attributes.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation.path, `Antragsteller`),
			content: (
				<EffekteDerFoerderungAbschlussEMob
					kostentraeger={KOSTENTRAEGER.Antragsteller}
					unternehmenId={get(getLocalstorageToken(), 'organisationId')}
				/>
			),
			formStruc: getFormStrucEffekteDerFoerderungAbschlussEMob(
				application,
				KOSTENTRAEGER.Antragsteller,
				get(getLocalstorageToken(), 'organisationId'),
			),
		},
	];
	const PartnerStruc = get(application, P.Foerderantrag.schema.attributes.Verbundpartner.path, []).map((ele: any, i: number) => {
		return {
			label: get(ele, P.Foerderantrag.schema.attributes.Verbundpartner.schema.attributes.Rechtsverbindlicher_Name_Der_Organisation.path.slice(P.Foerderantrag.schema.attributes.Verbundpartner.path.length + 1), `Verbundpartner ${i + 1}`),
			content: <EffekteDerFoerderungAbschlussEMob kostentraeger={KOSTENTRAEGER.Verbundpartner} unternehmenId={get(ele, 'Verbundpartner.id')} />,
			formStruc: getFormStrucEffekteDerFoerderungAbschlussEMob(application, KOSTENTRAEGER.Verbundpartner, get(ele, 'Verbundpartner.id')),
		};
	});
	return [...OrgaStruc, ...PartnerStruc];
};
